
  <app-card [cardOptionBtnValue]="'admin.collection.show.edit.collection'|translate" [cardOptionBtn]="true"
            [cardRouterLink]="'/back-office/collection/' + collection.id"
            [title]="'admin.collection.show.collection information'|translate">
    <div class="row">
      <div class="col-sm-12 col-xl-3">
        <p class="text-muted m-b-10">{{'doctrine.collection.name'|translate}}</p>
        <label class="m-b-15">{{collection.name}}</label>
      </div>
      <div class="col-sm-12 col-xl-3">
        <p class="text-muted m-b-10">{{'doctrine.collection.attach_models'|translate}}</p>
        <label class="m-b-15">{{collection.modelCount}}</label>
      </div>
      <div class="col-sm-12 col-xl-3">
        <p class="text-muted m-b-10">{{'doctrine.collection.status'|translate}}</p>
        <label class="m-b-15">{{(collection.status?'global.active':'global.inactive')|translate}}</label>
      </div>
      <div class="col-sm-12 col-xl-3">
        <p class="text-muted m-b-10">{{'doctrine.collection.separate_delivery_address'|translate}}</p>
        <label class="m-b-15">{{(collection.separateDeliveryAddress?'global.active':'global.inactive')|translate}}</label>
      </div>
      <div *ngIf="collection.endCustomerDelivery && collection.deliveryCostPerArticle" class="col-sm-12 col-xl-3">
        <p class="text-muted m-b-10">{{'doctrine.collection.info_delivery_cost_per_article'|translate}}</p>
        <label class="m-b-15">{{ collection.deliveryCostPerArticle | CustomCurrency}}</label>
      </div>
      <div *ngIf="collection.endCustomerDelivery && collection.dealerDeliveryCostPerArticle" class="col-sm-12 col-xl-3">
        <p class="text-muted m-b-10">{{'doctrine.collection.info_dealer_delivery_cost_per_article'|translate}}</p>
        <label class="m-b-15">{{ collection.dealerDeliveryCostPerArticle | CustomCurrency}}</label>
      </div>
    </div>
  </app-card>

  <app-card *ngIf="collection.models"
            [title]="('doctrine.collection.models'|translate) + ' (' + collection.models.length + ')'"
            [cardOptionBtnValue]="'admin.model.show.add.model'|translate"
            [cardOptionBtn]="true"
            [cardOptionBtnIcon]="'feather icon-plus'"
            [cardRouterLink]="'/back-office/model/add/' + collection.id"
>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
        <tr>
          <th>{{'doctrine.model.name'|translate}}</th>
          <th>{{'doctrine.model.code'|translate}}</th>
          <th>{{'doctrine.model.attach_products'|translate}}</th>
          <th>{{'doctrine.model.status'|translate}}</th>
          <th>{{'doctrine.model.position'|translate}}</th>
          <th class="text-end">{{'global.actions'|translate}}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let model of collection.models;let i = index">
          <td>{{model.name}}</td>
          <td>{{model.code}}</td>
          <td>{{model.productCount}}</td>
          <td>{{(model.status?'global.active':'global.inactive')|translate}}</td>
          <td>
            <input class="form-control" type="number" (blur)="positionChange(model.id,model.parentPosition)"  [name]="'position'+i" [(ngModel)]="model.parentPosition" style="max-width: 60px"  />
          </td>
          <td class="text-end">
            <span class="action-button">
              <a class="ripple light ms-2" routerLink="/back-office/model/{{model.id}}/{{collection.id}}">
                <i class="fa fa-pencil fa-lg"></i>
              </a>
            </span>
            <span class="action-button">
              <a class="action-button ripple light ms-2" (click)="showDeleteModal(model.id, model.name)">
                <i class="fa fa-remove fa-lg"></i>
              </a>
            </span>
          <td>
        </tr>
        </tbody>
      </table>
    </div>
  </app-card>


  <app-modal-basic #deleteModal>
    <div class="app-modal-header">
      <h4 class="modal-title">{{ 'global.soft_delete_title' | translate:{entity: 'Model'} }}</h4>
      <button type="button" class="close basic-close" (click)="deleteModal.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="app-modal-body">
      <p>{{ 'global.soft_delete_body' | translate}}: <span [innerHTML]="modelName"></span> ?</p>
    </div>
    <div class="app-modal-footer">
      <button type="button" class="btn btn-simple ripple ms-4" (click)="deleteModal.hide()">{{'global.cancel'|translate}}</button>
      <button type="button" class="btn btn-primary ripple light" (click)="softDelete()">{{'global.actions.delete'|translate}}</button>
    </div>
  </app-modal-basic>
